// extracted by mini-css-extract-plugin
module.exports = {"accordionSports":"styles_accordionSports__ekEJc","accordionTitle":"styles_accordionTitle__Lka_L","rigth":"styles_rigth__7RqCX","accordionLine":"styles_accordionLine__pzsQx"};